import CommonGroundGroup from "./CommonGroundGroup";

function CommonGrounds(props) {
	return (
		<div className="m-4 flex justify-evenly gap-4">
			<CommonGroundGroup
				key="for"
				type="for"
				role={props.role}
				commonGrounds={props.commonGrounds.for}
				updateCommonGroundPriorities={props.updateCommonGroundPriorities}
				openConfirmActionModal={props.openConfirmActionModal}
			/>
			<CommonGroundGroup
				key="against"
				type="against"
				role={props.role}
				commonGrounds={props.commonGrounds.against}
				updateCommonGroundPriorities={props.updateCommonGroundPriorities}
				openConfirmActionModal={props.openConfirmActionModal}
			/>
		</div>
	);
}

export default CommonGrounds;
